import DIApi from './_diApi';

/**
 *  API danh mục nội dung chi phí
 * ndhieu3 13.04.2023
 */
class FundStructureAPI extends DIApi {
  controllerName = 'FundStructures';
}
export default new FundStructureAPI();
